import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Icon from "@client.components/Icon";
import Pages from "@client.enums/pages";
import { processDemoLoginAsync } from "@client.pages/Login/reducer";

const DemoLogin = ({ hide }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogin = async () => {
    const result = await dispatch(processDemoLoginAsync());
    if (result.payload && !result.error) {
      navigate(Pages.Dashboard);
    }
  };

  return (
    !hide && (
      <>
        <button className="demo" onClick={handleLogin}>
          <Icon name="logo" />
          {t("components.DemoLogin.signin")}
        </button>
      </>
    )
  );
};

DemoLogin.propTypes = {
  hide: PropTypes.bool,
};

export default DemoLogin;
